module.exports = __webpack_public_path__ + "image-b0ab171fb202.png";